export default {
      id: "es-ga-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#es-ga",
      toString: function () {
        return this.url;
      }
    }